export const TEL_COUNTRIES = [
  'pl',
  'sk',
  'ua',
];
